import type { FaireProductEntity } from "../../entity_types/product";

export const p_kpnqbrwtyw: FaireProductEntity = {
  token: "p_kpnqbrwtyw",
  type: "product",
  name: "Non-Aerosol Volumizing Dry Shampoo Powder - Organic - USA",
  brandToken: "b_2raaesf5hr",
  brandName: "Hair Dance",
  imageUrl:
    "https://cdn.faire.com/fastly/f1927928c96d0c14ab9dca3219ad12029a7170efc57afb6733f6e0871d2e0d25.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78049d1eaab337010372799a39294a56d6577c2d5607afe4238930453cfcf14d.jpeg",
    "https://cdn.faire.com/fastly/fa71f5eeefe70eaecbe9e4f830ee0e89973be5a780326105b8aaccd8061a144d.jpeg",
    "https://cdn.faire.com/fastly/a0c1175d71e65b134ae4a2a5b068c65580fb9abbf07c3430f46e9d2000840c54.png",
    "https://cdn.faire.com/fastly/af2701588fd95b3f0d6428ab034aaaa95bd0aeec3617aee9550ab2271db1b0f8.png",
    "https://cdn.faire.com/fastly/cfbeb936be9aaa78ff390ff28bc41a9f5f754de4e8089b2b18e747c303fbbc84.png",
    "https://cdn.faire.com/fastly/cfd9864ca12801bdc6828e9ecc8f3d45e2f82ef4e04ba985cb9ff0277413dd5a.png",
    "https://cdn.faire.com/fastly/670d20a59e55305806f06f86891a2aa24a57d1a2d8fced4cf938aeb74692457f.png",
    "https://cdn.faire.com/fastly/7eb9e2be09fd20c05ec61d09f1c25106e26f792ee2997d0c468a9830ff00063d.jpeg",
    "https://cdn.faire.com/fastly/951eb1dcd4f8020dd2ef11e7a0e312e62f3008ba85d2c8a68db8ab8e5ccc3f23.jpeg",
    "https://cdn.faire.com/fastly/6fdb922731f036f152324f84e3a971d95805d0c8927b9b4a680080b1332fc3c6.png",
    "https://cdn.faire.com/fastly/0c2bd1c502691900ec6f81f223effe27ac3b75d3d17be0da4e144eece238846c.png",
    "https://cdn.faire.com/fastly/eeb267e5f1205df8accad8596eb21cb2ae83fb66616f46807aaadc39453b29f0.png",
    "https://cdn.faire.com/fastly/9888718dae27940fd694aa48d8bea5381523616b3fdd9ebce90528f12fdb60ed.jpeg",
    "https://cdn.faire.com/fastly/857082ef3af0e5099dd572e4244cfaeae63036625f761bd0a9109afed10b6bf6.jpeg",
    "https://cdn.faire.com/fastly/7128bbff4e2bf9e76920ae4e8f2a10f15f02201e6feb6c2c5d5fc4f37692f3b9.jpeg",
  ],
  priceDollars: 8,
  description:
    "DESCRIPTION\nSuitable for all hair colors, including dark or black hair, our bestselling Volumizing Dry Shampoo absorbs oil and residue, leaving hair refreshed and voluminous in between shampoo washes. Infused with a soothing natural scent, its aromatherapeutic Lavender essential oil helps calm your mood.\n\nHOW DO I USE IT? \nDivide hair onto sections. On dry hair, spray powder onto the roots or wherever volume is desired. Brush through or massage into scalp with fingertips to reveal the look of refreshed and fuller-looking hair. Style as desired. \n\nINGREDIENTS\nOrganic Oryza Sativa (Rice) Starch, Organic Colloidal Oatmeal, Silica, Lavandula Angustifolia (Lavender) Oil Organic Olea Europaea (Olive) Leaf.\n\n*Please note that our 1.6 oz size includes a paper cardboard tube packaging to hold the dry shampoo bottle. The 0.8 oz sizes do NOT.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:01.777Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
